import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  pageSeo,
  publicProfileIdentifier,
  renderSeoHead,
  type PageSeo,
} from '@garagegymbros/domain';

export function applyPageMetadata(metadata: PageSeo) {
  const seo =
    window.location.origin === 'https://garagegymbros.com'
      ? metadata
      : { ...metadata, indexable: false };
  document.head
    .querySelectorAll('[data-ggb-seo], link[rel="canonical"]')
    .forEach((node) => node.remove());
  const template = document.createElement('template');
  template.innerHTML = renderSeoHead(seo);
  const title = template.content.querySelector('title');
  if (title) {
    document.title = title.textContent ?? seo.title;
    title.remove();
  }
  document.head.append(template.content);
}
export function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Keep correct server-rendered profile metadata while its normal RLS reads finish.
    if (publicProfileIdentifier(pathname)) {
      const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (canonical && new URL(canonical.href).pathname === pathname) return;
    }
    applyPageMetadata(pageSeo(pathname));
  }, [pathname]);
  return null;
}
